import { ActionMeta } from 'redux-actions';

import { CANCEL, CLEAR, FAILURE, NEVER, START, SUCCESS } from 'react-redux-await-control/dist/constants';
import { BaseAction } from 'react-redux-await-control/dist/types';

type AsyncActionState = 'START' | 'SUCCESS' | 'FAILURE' | 'CANCEL' | 'UPDATE';
type AsyncActionReducerData = [AsyncActionState, any] | [AsyncActionState];
type AsyncActionReducerPlusUpdate = {
  [key: string]: AsyncActionReducerData;
};

const UPDATE = 'UPDATE';

const formatRequestName = (requestName: string, { payload, meta }: ActionMeta<any, any>) => {
  const actionPayloadMeta: any = {};

  if (typeof payload === 'object') {
    Object.assign(actionPayloadMeta, payload);
  }

  if (typeof meta === 'object') {
    Object.assign(actionPayloadMeta, meta);
  }

  if (actionPayloadMeta.actionId) {
    return `${requestName}_${actionPayloadMeta.actionId.toString().toUpperCase()}`;
  }

  return requestName;
};

export default function reducer(
  state: AsyncActionReducerPlusUpdate = {},
  action: BaseAction,
): AsyncActionReducerPlusUpdate {
  const { type, payload, meta } = action as any;
  const matches = /(.*)\/(.*)_(START|SUCCESS|FAILURE|CANCEL|CLEAR|UPDATE)/.exec(type);

  if (!matches) return state;

  const [, , requestName, requestState] = matches;

  const formattedRequestName = formatRequestName(requestName, action as ActionMeta<any, any>);

  if (requestState === CLEAR) {
    const { [formattedRequestName]: _, ...rest } = state;
    return rest;
  }

  const resultStatus = [SUCCESS, FAILURE, UPDATE];

  if (
    state[formattedRequestName] &&
    [CANCEL, FAILURE].includes(state[formattedRequestName][0]) &&
    requestState !== START
  ) {
    return state;
  }

  if (requestState === START) {
    if (meta?.store) {
      const current = state[formattedRequestName];
      return { ...state, [formattedRequestName]: current ? [START, current[1]] : [START, NEVER] };
    }

    return { ...state, [formattedRequestName]: [START] };
  }

  if (requestState === UPDATE) {
    return { ...state, [formattedRequestName]: [SUCCESS, payload] };
  }

  if (state[formattedRequestName] && [...resultStatus, CANCEL].includes(requestState)) {
    const storingData: AsyncActionReducerData = [requestState as AsyncActionState];

    if (meta?.store) {
      storingData.push(resultStatus.includes(requestState) ? payload : undefined);
    }

    return { ...state, [formattedRequestName]: storingData };
  }

  return state;
}
